<template>
  <v-col
    :cols="cols"
    class="pa-0 pr-1"
  >
    <v-subheader style="height: auto; min-height: 48px;">
      <span>
        {{
        attribute[`label_${$i18n.locale}`] ||
        'No translation'
        }}
        <!--
        <template
          v-if="attribute.measure_unit"
        >
          <span
            class="caption"
            v-html="attribute.measure_unit"
          />
        </template>
        -->
      </span>
    </v-subheader>
  </v-col>
</template>

<script>
export default {
  props: {
    cols: {
      required: true,
      type: Number,
    },
    attribute: {
      required: true,
      type: Object,
    },
  }
}
</script>

